import ky from 'ky';
import { env } from '@/shared/lib/env';
import { getToken, redirectToLogin } from '@/shared/http/client';
import { getOperadorTokenForUrl, OPERADOR_EXPIRADO_EVENT } from '../utils/session';

// Cliente HTTP das rotas do atendimento (PRAT-64). Nas rotas da loja do
// operador manda o JWT do operador (sessionStorage); nas demais, o token do
// cliente, como o `client` padrão. O 401 do operador NÃO leva ao login do
// cliente: avisa a tela para pedir que o operador abra de novo pelo gestor.
export const atendimentoClient = ky.create({
  prefixUrl: env.VITE_API_URL,
  hooks: {
    beforeRequest: [
      request => {
        const token = getOperadorTokenForUrl(request.url) ?? getToken();
        if (token) request.headers.set('Authorization', `Bearer ${token}`);
      },
    ],
    afterResponse: [
      (request, _options, response) => {
        if (response.status !== 401) return response;

        if (getOperadorTokenForUrl(request.url)) {
          window.dispatchEvent(new CustomEvent(OPERADOR_EXPIRADO_EVENT));
        } else {
          redirectToLogin();
        }
        return response;
      },
    ],
  },
});
